<p-table
  selectionMode="single"
  [value]="datas"
  [lazy]="false"
  [paginator]="false"
  rowHover="false"
  resizableColumns="true"
  *ngIf="isLoaded; else loading"
  [class.no-zebra-shading]="true"
  [responsive]="true"
>
  <ng-template pTemplate="header">
    <tr>
      <th>Service</th>
      <th>Vehicle Classification</th>
      <th>Service Offered</th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-data>
    <tr [class]="getRowStyle">
      <td>
        <span>{{ data.serviceTypeName + (data.notes ? ' (' + data.notes + ')' : '') }}</span>
      </td>
      <td>
        <span>
          {{
            (data.minWeight > 0 ? data.minWeight + 't' : '') +
              (data.maxWeight > 0
                ? data.minWeight > 0
                  ? ' - ' + data.maxWeight + 't'
                  : 'Less than ' + data.maxWeight + 't'
                : data.minWeight > 0
                ? '+'
                : 'All')
          }}
        </span>
      </td>
      <td>
        <p-checkbox
          [(ngModel)]="data.isServiceOffered"
          name="isServiceOffered"
          [ngModelOptions]="{ standalone: true }"
          binary="true"
          (onChange)="changeIsServiceOffered(data)"
        ></p-checkbox>
      </td>
    </tr>
  </ng-template>
</p-table>
<ng-template #loading>Loading...</ng-template>
